<div class="flex flex-column">
  <app-device-selector
    [(visible)]="displayDevicesSelector"
    [selection]="currentDevices"
    [tenant]="synopticInfoForm.get('tenant').value"
    [organization]="synopticInfoForm.get('organization').value"
    [actionButtons]="selectDevicesActions"
    selectionMode="multiple"
  ></app-device-selector>
  <div class="flex justify-content-center pt-2 pb-3">
    <button
      [disabled]="!synopticInfoForm.get('tenant').value"
      (click)="displayDevicesSelector = true"
      [label]="'select.devices' | transloco"
      pButton
      pRipple
    ></button>
  </div>
  <div class="p-datatable p-component">
    <p-table
      [(first)]="devicesFirst"
      [(rows)]="devicesRows"
      [value]="currentDevices"
      [totalRecords]="currentDevices.length"
      [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
      [paginator]="true"
      styleClass="p-datatable-striped"
      sortField="name"
      #devicesTable
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="serialNumber">
            {{'attribute.serialNumber' | transloco}}
            <p-sortIcon field="serialNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="description">
            {{'attribute.description' | transloco}}
            <p-sortIcon field="description"></p-sortIcon>
          </th>
          <th pSortableColumn="deviceCategory.name">
            {{'model.category' | transloco}}
            <p-sortIcon field="deviceCategory.name"></p-sortIcon>
          </th>
          <th class="w-4rem"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-device>
        <tr>
          <td>
            <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
            <p class="text-right md:text-left">{{device.serialNumber}}</p>
          </td>
          <td class="devices-table-description-td">
            <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
            <p class="mb-0 text-right md:text-left table-description">{{device.description}}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
            <p class="text-right md:text-left">{{device.deviceCategory ? device.deviceCategory.name : ''}}</p>
          </td>
          <td class="p-0">
            <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
            <div class="flex justify-content-end">
              <button
                (click)="removeDevice(device); devicesTable._filter()"
                class="p-button-rounded btn-danger-light mr-2"
                pButton
                pRipple
                icon="pi pi-trash"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
